const crypto = require('crypto');

// Encryption configuration
const algorithm = 'aes-256-cbc';
const key = Buffer.from('12345678901234567890123456789012', 'utf8'); // 32-byte key
const iv = Buffer.from('1234567890123456', 'utf8'); // 16-byte IV

// Enhanced encrypt function with logging
function encrypt(text) {
    try {
        console.log('Encrypting text:', text);
        console.log('Key length:', key.length, 'bytes');
        console.log('IV length:', iv.length, 'bytes');
        if(text == undefined){
            return;
        }
        const cipher = crypto.createCipheriv(algorithm, key, iv);
        let encrypted = cipher.update(text, 'utf8', 'base64');
        encrypted += cipher.final('base64');
        
        console.log('Raw encrypted result:', encrypted);
        
        // Make URL safe if needed
        const urlSafeEncrypted = encrypted.replace(/\+/g, '-').replace(/\//g, '_');
        console.log('URL safe encrypted result:', urlSafeEncrypted);
        
        return urlSafeEncrypted;
    } catch (error) {
        console.error('Encryption failed:', error);
        throw error;
    }
}

// Enhanced decrypt function with extensive error handling
function decrypt(encryptedText) {
    try {
        console.log('Attempting to decrypt:', encryptedText);
        
        if (!encryptedText) {
           console.log('Encrypted text is empty or undefined');
        }
        
        // Convert from URL safe format if needed
        const standardBase64 = encryptedText.replace(/-/g, '+').replace(/_/g, '/');
        console.log('Standardized base64:', standardBase64);
        
        // Try to add padding if needed
        let paddedText = standardBase64;
        if (standardBase64.length % 4 !== 0) {
            paddedText = standardBase64 + '='.repeat((4 - standardBase64.length % 4) % 4);
            console.log('Added padding, now:', paddedText);
        }
        
        const decipher = crypto.createDecipheriv(algorithm, key, iv);
        let decrypted = decipher.update(paddedText, 'base64', 'utf8');
        decrypted += decipher.final('utf8');
        
        console.log('Successfully decrypted to:', decrypted);
        return decrypted;
    } catch (error) {
        console.error('Decryption error details:', error);
        
        // Try an alternative approach if the first attempt fails
        try {
            console.log('Trying alternative decryption approach...');
            
            // Try direct base64 decoding first to see if that's the issue
            const rawData = Buffer.from(encryptedText, 'base64');
            console.log('Raw data length after base64 decode:', rawData.length, 'bytes');
            
            const decipher = crypto.createDecipheriv(algorithm, key, iv);
            const decrypted = Buffer.concat([
                decipher.update(rawData),
                decipher.final()
            ]).toString('utf8');
            
            console.log('Alternative decryption successful:', decrypted);
            return decrypted;
        } catch (altError) {
            console.error('Alternative decryption also failed:', altError);
            console.log('Unable to decrypt data using multiple methods');
        }
    }
}

// Verification test
function testEncryptionDecryption() {
    try {
        const original = "Test message 123!";
        console.log('\n--- ENCRYPTION TEST ---');
        const encrypted = encrypt(original);
        
        console.log('\n--- DECRYPTION TEST ---');
        const decrypted = decrypt(encrypted);
        
        console.log('\n--- RESULTS ---');
        console.log('Original:', original);
        console.log('Encrypted:', encrypted);
        console.log('Decrypted:', decrypted);
        console.log('Success:', original === decrypted);
    } catch (error) {
        console.error('Test failed:', error);
    }
}

// Run the test
testEncryptionDecryption();

// Export functions
module.exports = {
    encrypt,
    decrypt
};